import { render } from "./MessagesIcon.vue?vue&type=template&id=5972697a&scoped=true"
import script from "./MessagesIcon.vue?vue&type=script&lang=js"
export * from "./MessagesIcon.vue?vue&type=script&lang=js"

import "./MessagesIcon.vue?vue&type=style&index=0&id=5972697a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2677690992/src/emulator.totogidemos.com/frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5972697a"]])

export default __exports__